import { ModifiedDrawer } from "components/common"
import TaskReviewsTabs from "../taskReviewsTabs/taskReviewsTabs"
import { forwardRef } from "react"
import { t } from "i18next"
import { useLazyGetClientTaskLogsQuery } from "features/shared/api"

const TaskOverviewModal = forwardRef((props, ref) => {
  const { client, lead, getClientLogs, taskTableProps, tabKey } = props
  const [getClientTaskLogs, { data: clientLeads, loading }] = useLazyGetClientTaskLogsQuery()

  const onDrawerVisible = () => {
    // added this for leads, todos and tasks. This will get us all the leadsIds for that client.
    if (client) {
      getClientTaskLogs(client?.id)
    }
  }

  return (
    <ModifiedDrawer
      width={1200}
      ref={ref}
      title={t("Task Overview")}
      onDrawerVisible={getClientLogs && onDrawerVisible}
      destroyOnClose={true}
      onClick={e => {
        e.stopPropagation()
      }}
      onClose={e => {
        e.stopPropagation()
        ref?.current?.setVisible(false)
      }}
    >
      <TaskReviewsTabs
        client={client}
        lead={lead}
        clientLeads={clientLeads}
        taskTableProps={taskTableProps}
        tabKey={tabKey}
      />
    </ModifiedDrawer>
  )
})

export default TaskOverviewModal
